import React from "react";
import "../../assets/css/video-mundial.css";

const VideoMundialComponent: React.FC = () => {
  return (
    <section className="video-mundial-section">
      <div className="video-mundial-container">
        
        <h2 className="video-mundial-title">
          ¿Te imaginas estar en<br />la Copa Mundial de la FIFA 2026™?
        </h2>
        
        <div className="video-mundial-wrapper">
          <iframe 
            width="100%" 
            height="100%" 
            src="https://www.youtube.com/embed/HqBKIvQc60c?si=NWjFE5Itzuel3DM7&autoplay=1&mute=1&loop=1&playlist=HqBKIvQc60c" 
            title="Hyundai Video" 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen
          ></iframe>
        </div>

      </div>
    </section>
  );
};

export default VideoMundialComponent;
